// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3mtZl","rightAdornment":"Header_rightAdornment__30bvA"};